import ReadsSequence, { getReadsSequenceHeight } from './ReadsSequence';
export { getReadsSequenceHeight };
export default ReadsSequence;
